import * as mainActions from './actions';
import { actions as sliceActions, reducer } from './slice';

const actions = {
  ...mainActions,
  ...sliceActions,
};

export { actions, reducer };
